import { render, staticRenderFns } from "./Properties.vue?vue&type=template&id=b8b6aa6e&"
import script from "./Properties.vue?vue&type=script&lang=js&"
export * from "./Properties.vue?vue&type=script&lang=js&"
import style0 from "./Properties.vue?vue&type=style&index=0&id=b8b6aa6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports